import { StatusType } from "@/types/StatusType";
import { TransactionDirection } from "@/types/transaction/TransactionType";

export enum BudgetEventType {
  SUBSCRIPTION_BUDGET_CREATED = "CreatedEvent",
  POSTPAID_BUDGET_CREATED = "BudgetCreatedEvent",
  BUDGET_CAP_UPDATED = "BudgetCapUpdatedEvent",
  BUDGET_CREDITED = "BudgetCreditedEvent",
  BUDGET_DEBITED = "BudgetDebitedEvent",
  CAMPAIGN_BUDGET_ALLOCATED = "CampaignBudgetAllocatedEvent",
  CAMPAIGN_BUDGET_REMOVED = "CampaignBudgetRemovedEvent",
  CAMPAIGN_BUDGET_UPDATED = "CampaignBudgetUpdatedEvent",
  CAMPAIGN_INVOICE_UPDATED = "CampaignInvoiceUpdatedEvent",
  CAMPAIGN_INVOICED = "CampaignInvoicedEvent",
  CHANNEL_BUDGET_ALLOCATED = "ChannelBudgetAllocatedEvent",
  CHANNEL_BUDGET_REMOVED = "ChannelBudgetRemovedEvent",
  CHANNEL_BUDGET_UPDATED = "ChannelBudgetUpdatedEvent",
  CHANNEL_INVOICE_UPDATED = "ChannelInvoiceUpdatedEvent",
  CHANNEL_INVOICED = "ChannelInvoicedEvent",
  MONTHLY_BUDGET_CREDITED = "MonthlyBudgetCreditedEvent",
  MONTHLY_BUDGET_UPDATED = "MonthlyBudgetUpdatedEvent",
  OVERSPEND_ALLOWED_CHANGED = "AllowOverspendUpdatedEvent",
  PAYMENT_TYPE_UPDATED = "PaymentTypeUpdatedEvent",
  // CampaignIntegration events (new integration-based model)
  BUDGET_RENEWED = "BudgetRenewedEvent",
  CAMPAIGN_INTEGRATION_BUDGET_ALLOCATED = "CampaignIntegrationBudgetAllocatedEvent",
  CAMPAIGN_INTEGRATION_BUDGET_REMOVED = "CampaignIntegrationBudgetRemovedEvent",
  CAMPAIGN_INTEGRATION_BUDGET_UPDATED = "CampaignIntegrationBudgetUpdatedEvent",
  CAMPAIGN_INTEGRATION_INVOICED = "CampaignIntegrationInvoicedEvent",
  CAMPAIGN_INTEGRATION_INVOICE_UPDATED = "CampaignIntegrationInvoiceUpdatedEvent",
}

export const transactionTypeMap: Record<string, StatusType> = {
  [BudgetEventType.SUBSCRIPTION_BUDGET_CREATED]: "success",
  [BudgetEventType.POSTPAID_BUDGET_CREATED]: "success",
  [BudgetEventType.BUDGET_RENEWED]: "success",
  [BudgetEventType.BUDGET_CREDITED]: "success",
  [BudgetEventType.BUDGET_DEBITED]: "error",
  [BudgetEventType.CAMPAIGN_BUDGET_ALLOCATED]: "warning",
  [BudgetEventType.CAMPAIGN_BUDGET_REMOVED]: "warning",
  [BudgetEventType.CAMPAIGN_BUDGET_UPDATED]: "neutral",
  [BudgetEventType.CAMPAIGN_INVOICE_UPDATED]: "archive",
  [BudgetEventType.CAMPAIGN_INVOICED]: "error",
  [BudgetEventType.CHANNEL_BUDGET_ALLOCATED]: "warning",
  [BudgetEventType.CHANNEL_BUDGET_REMOVED]: "warning",
  [BudgetEventType.CHANNEL_BUDGET_UPDATED]: "neutral",
  [BudgetEventType.CHANNEL_INVOICE_UPDATED]: "archive",
  [BudgetEventType.CHANNEL_INVOICED]: "error",
  [BudgetEventType.MONTHLY_BUDGET_CREDITED]: "success",
  [BudgetEventType.MONTHLY_BUDGET_UPDATED]: "neutral",
  [BudgetEventType.OVERSPEND_ALLOWED_CHANGED]: "neutral",
  [BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_ALLOCATED]: "warning",
  [BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_REMOVED]: "warning",
  [BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_UPDATED]: "neutral",
  [BudgetEventType.CAMPAIGN_INTEGRATION_INVOICED]: "error",
  [BudgetEventType.CAMPAIGN_INTEGRATION_INVOICE_UPDATED]: "archive",
};

export const transactionDirectionMap: Record<string, TransactionDirection> = {
  [BudgetEventType.POSTPAID_BUDGET_CREATED]: "Credit",
  [BudgetEventType.BUDGET_RENEWED]: "Credit",
  [BudgetEventType.BUDGET_CREDITED]: "Credit",
  [BudgetEventType.BUDGET_DEBITED]: "Debit",
  [BudgetEventType.CAMPAIGN_BUDGET_ALLOCATED]: "Debit",
  [BudgetEventType.CAMPAIGN_BUDGET_REMOVED]: "Credit",
  [BudgetEventType.CAMPAIGN_INVOICED]: "Debit",
  [BudgetEventType.CHANNEL_BUDGET_ALLOCATED]: "Debit",
  [BudgetEventType.CHANNEL_BUDGET_REMOVED]: "Credit",
  [BudgetEventType.CHANNEL_INVOICED]: "Debit",
  [BudgetEventType.MONTHLY_BUDGET_CREDITED]: "Credit",
  [BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_ALLOCATED]: "Debit",
  [BudgetEventType.CAMPAIGN_INTEGRATION_BUDGET_REMOVED]: "Credit",
  [BudgetEventType.CAMPAIGN_INTEGRATION_INVOICED]: "Debit",
};
